<span
  class="custom-pill-container"
  [ngStyle]="styleIconPill"
  [attr.aria-label]="altText || label"
  [class.clickable]="canClick"
  [class.pill-medium]="textWeight === 'medium'"
>
  <i *ngIf="iconType === 'material' && resolvedIconName" class="material-icons">
    {{ resolvedIconName }}
  </i>

  <img
    *ngIf="iconType === 'image' && resolvedImageSrc"
    [src]="resolvedImageSrc"
    [alt]="altText || label"
    [style.width]="imageWidth"
    [style.height]="imageHeight"
  />

  <span>{{ label }}</span>
  <span *ngIf="sublabel" class="sublabel">{{ sublabel }}</span>
</span>
